import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useState } from 'react';
import { useDevice } from '../../contexts/DeviceContext.js';
import { cn } from '../../lib/utils.js';
import { LineIcon } from './icons/LineIcon.js';

const IconButtonToggle = ({
  items,
  onChange,
  className,
  size = "default"
}) => {
  const { isDesktop } = useDevice();
  const [activeId, setActiveId] = useState(null);
  const handleClick = (id) => {
    setActiveId(id);
    onChange?.(id);
  };
  return /* @__PURE__ */ jsx(Fragment, { children: items.map((item) => {
    const isActive = activeId === item.id;
    return /* @__PURE__ */ jsx(
      "button",
      {
        className: cn(
          "group radio-wrap relative flex items-center gap-2 bg-base-white cursor-pointer shadow-[inset_0_0_0_1px_var(--color-border-basic-04)]  rounded-[12px] text-center card justify-center w-full",
          isActive && "shadow-[inset_0_0_0_2px_#2772c7]",
          className
        ),
        onClick: () => handleClick(item.id),
        id: item.id,
        "aria-label": `${item.title}`,
        children: size === "default" ? /* @__PURE__ */ jsxs(
          "span",
          {
            className: cn(
              isDesktop && "h-[200px]",
              "flex flex-col items-center justify-center gap-3 py-[28px] px-5 w-full"
            ),
            children: [
              /* @__PURE__ */ jsx(
                LineIcon,
                {
                  icoName: item.icon,
                  icoColor: "var(--color-icon-basic-01)",
                  type: "lg",
                  className: "flex-grow-0"
                }
              ),
              /* @__PURE__ */ jsx("span", { className: "body-lg text-basic-02 text-center inline-block whitespace-pre-line break-keep font-weight-medium", children: item.title })
            ]
          }
        ) : /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center justify-center px-5 h-[124px]", children: [
          /* @__PURE__ */ jsx(
            LineIcon,
            {
              icoName: item.icon,
              icoColor: "var(--color-neutral-900)",
              type: "xl",
              className: "flex-grow-0"
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "body-lg font-weight-medium mt-3 text-basic-02 text-center inline-block !leading-none", children: item.title })
        ] })
      },
      item.id
    );
  }) });
};

export { IconButtonToggle };
